export const DARK_MODE_ALLOWED_PREFIXES = [
  "/financial",
  "/dashboard",
  "/learn",
  "/support",
  "/account",
] as const;

function isPathUnderPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * Regra de negócio:
 * - Dark mode só é permitido dentro da área "logada" (rotas protegidas).
 * - Páginas públicas (login/cadastro/checkout/planos/termos/etc) ficam sempre em light mode,
 *   mesmo que o usuário tenha preferência salva em "dark".
 */
export function isDarkModeAllowed(pathname: string, hasAccessToken: boolean): boolean {
  if (!hasAccessToken) return false;
  return DARK_MODE_ALLOWED_PREFIXES.some((prefix) => isPathUnderPrefix(pathname, prefix));
}

export function getForcedTheme(
  pathname: string,
  hasAccessToken: boolean
): "light" | undefined {
  return isDarkModeAllowed(pathname, hasAccessToken) ? undefined : "light";
}











